import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=fc775d50&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"
import style0 from "./Typography.scss?vue&type=style&index=0&id=fc775d50&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc775d50",
  null
  
)

export default component.exports